export const RECORD_PRINTINFO = 'RECORD_PRINTINFO';
export const RECORD_USERID = 'RECORD_USERID';
export const RECORD_PLATFORMINFO = 'RECORD_PLATFORMINFO';
export const RECORD_PLATFORMINFO_LOCAL = 'RECORD_PLATFORMINFO_LOCAL';
export const RECORD_USERINFO = 'RECORD_USERINFO';
export const RECORD_ORDERINFO = 'RECORD_ORDERINFO';
export const RECORD_SPECINFO = 'RECORD_SPECINFO';
export const RECORD_PROCESSED_PHOTO = 'RECORD_PROCESSED_PHOTO';
export const MAKE_PHOTO = 'MAKE_PHOTO';
export const RECORD_SELECTED_BG = 'RECORD_SELECTED_BG';
export const RECORD_SEARCH_RESULTS = 'RECORD_SEARCH_RESULTS';
export const RECORD_LAST_SEARCH = 'RECORD_LAST_SEARCH';
export const RECORD_HOTSEARCH = 'RECORD_HOTSEARCH';
export const RECORD_SERVICE_TEL = 'RECORD_SERVICE_TEL';
export const RECORD_CONSIGNEE_INFO = 'RECORD_CONSIGNEE_INFO';
export const RECORD_PRICE = 'RECORD_PRICE';
export const RECORD_PRINTPRICE = 'RECORD_PRINTPRICE';
export const RECORD_PRINT_QTY = 'RECORD_PRINT_QTY';
export const SET_LOADING = 'SET_LOADING';
export const HANDLE_TRANCE = 'HANDLE_TRANCE';
export const PRINTNUMBER = 'PRINTNUMBER';
export const RECORD_EXTRAINFO = 'RECORD_EXTRAINFO'
export const DELGROUPLIST = 'DELGROUPLIST';
export const SETGROUPLISTNUM = 'SETGROUPLISTNUM';
export const ADDGROUPLIST = 'ADDGROUPLIST';
export const EXTRAINIT = 'EXTRAINIT';
export const UPDATEGROUPLISTPRICE = 'UPDATEGROUPLISTPRICE';
export const SETRULECOLOR = 'SETRULECOLOR';
export const SETPRINTEXTRA = 'SETPRINTEXTRA';
